import { Dispatch } from "common/types";

import { reconcileCourseEnrolments } from "seneca-common/features/enrollments/features/course-enrollments/service/actions";
import { reconcileMemories } from "seneca-common/features/memories/service";
import { reconcileStudyStats } from "seneca-common/features/session/actions/reconcile";
import {
  signInSuccessAsGuest,
  updateUserPreferences as updateUserPreferencesLocally
} from "seneca-common/features/user/state";

import { persistChangedUserPreferences } from "../../actions/preferences";

export function signInAsGuest(region: string | null | undefined) {
  return function (dispatch: Dispatch) {
    region &&
      dispatch(
        updateUserPreferencesLocally({
          region
        })
      );
    dispatch(signInSuccessAsGuest());
  };
}

export function reconcileData() {
  return async function (dispatch: Dispatch) {
    await Promise.all([
      dispatch(persistChangedUserPreferences()),
      dispatch(reconcileStudyStats()),
      dispatch(reconcileMemories()),
      dispatch(reconcileCourseEnrolments())
    ]);
  };
}
